{
  "title": "Flame Arrows",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "3rd-level transmutation",
  "level": 3,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You touch a quiver containing arrows or bolts. When a target is hit by a ranged weapon attack using a piece of ammunition drawn from the quiver, the target takes an extra 1d6 fire damage. The spell’s magic ends on the piece of ammunition when it hits or misses, and the spell ends when twelve pieces of ammunition have been drawn from the quiver.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the number of pieces of ammunition you can affect with this spell increases by two for each slot level above 3rd."
  ],
  "spellLists": ["artificer", "druid", "ranger", "sorcerer", "wizard"]
}
